module.exports = "/assets/247682da7e55479df9ae36c24b195169.svg";